webpackJsonp([6],{

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


function loadPageInBackGround(url, e, dept) {
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-page-content').length > 0) {
    e.preventDefault();
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      richNavAjax: true
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(url, data, function (data) {
      var content = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(data);
      var $pageContent = content.find('.js-page-content');
      if ($pageContent.length === 0) return;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-page-content').html($pageContent);

      if (dept === 'F' && typeof window.insertWomenCarousalMarkupsByAjax == 'function') {
        window.insertWomenCarousalMarkupsByAjax();
      } else if (dept === 'M' && typeof window.insertMenCarousalMarkupsByAjax == 'function') {
        window.insertMenCarousalMarkupsByAjax();
      } // We need to manually reload the top banner carousel when the page is partially reloaded
      // after click on left nav department link.
      // top banner reload issue workaround - start


      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-top-banner-department-reload').html(content.find('.js-top-banner-department-reload').html());
      var banerSlideshow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slideshow');

      if (banerSlideshow.children('.banner--slider-list__item').length > 1) {
        banerSlideshow.slick({
          autoplay: true,
          autoplaySpeed: 6000,
          prevArrow: '.banner__slick-prev',
          nextArrow: '.banner__slick-next',
          touchThreshold: 20
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.banner__slick-next, .banner__slick-prev').on('click', function () {
          banerSlideshow.slick('slickPause');
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.banner__slick-next, .banner__slick-prev').hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.banner--slider-list').show();
      } // top banner reload issue workaround - end


      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#rev-logo').html(content.find('#rev-logo').html());
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#rev-logo').attr('href', content.find('#rev-logo').attr('href'));
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#global-nav-div').html(content.find('#global-nav-div').html());
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('scroll.lazyloadimage');
      initMobileHp();
      content.find('#js-footer-container').find("script").each(function () {
        eval(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).text());
      });
      history.pushState("", document.title, url);
    });
  }
}

function richNavHpClickHandler(e) {
  if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass('js-active')) return;

  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass('js-rich-nav-womens')) {
    loadPageInBackGround("/r/mobile/index_women.jsp?main_hm", e, 'F');
  }

  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass('js-rich-nav-mens')) {
    loadPageInBackGround("/r/mobile/index_men.jsp?main_hm", e, 'M');
  }

  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass('js-rich-nav-beauty')) {
    loadPageInBackGround("/content/lp/beauty/mobile/?main_hm", e);
  }

  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass('js-rich-nav-collections')) {
    loadPageInBackGround("/content/lp/collections-shop/mobile/?main_hm", e);
  }
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-global__account, .menu__my-settings, .js-global__customercare, .js-global__info').find('.nav-side__link').each(function () {
    var href = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href');

    if (href && window.location.pathname !== '/r/mobile/' && href.indexOf(window.location.pathname) !== -1) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass("u-underline");
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-rich-nav-hp').click(richNavHpClickHandler);
});

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_sidebar__ = __webpack_require__(214);


window.clearSearchCookies = function () {
  createTransientCookie('searchBrandFilterByRevolveR1', '');
  createTransientCookie('searchDepartmentFilterByRevolveR1', '');
  createTransientCookie('searchColourFilterByRevolveR1', '');
  createTransientCookie('searchCategoryFilterByRevolveR1', '');
};

/***/ })

},[317]);


// WEBPACK FOOTER //
// dist/header.js